import React from 'react';

function SecurityTaskQuestion({ question, value = '', onChange }) {
  return (
    <textarea
      name={`question-${question.id}`}
      placeholder={question.placeholder || "Explain the security vulnerability and your solution..."}
      rows={6}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full mt-2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  );
}

export default SecurityTaskQuestion;
